import { postRequest } from ".";

export const attemptIncreaseCounter = (payload) =>
  postRequest(`offers/${payload}/counter/1`);
